import * as types from '../mutation-types'
import { API, message } from '../../api'
import { MOMENT_TIME } from '../../momenttime';

export default {
    namespaced: true,
    state: {
        gotAllExtList: false,
        showVersionReminder: false,
        showDownloadReminder: true,
        showDetailReminder: false,
        versionExtTime: {},
        versionKeyArr: ['1.5.0'],
        detailExtTime: {},      // 八字详情提示
        detailKeyArr: ['name', 'fate', 'share', 'label'],       // 八字详情提示:key数组
        showShareReminder: false,
        shareExtTime: {},       // 分享八字提示
        shareKeyArr: ['save', 'collate'],         // 分享八字提示:key数组
        showCollateReminder: false,
        collateExtTime: {},
        collateKeyArr: ['float', 'label'],
        aitips: '',                         // 测算入口配置
        aiButtonClickedStatus: true        // 测算入口按钮状态
    },
    getters: {},
    mutations: {
        [types.REMINDER_UPDATE_STATUS_DATA](state, data) {
            var newData = data == [] ? {} : data;
            console.log('REMINDER_UPDATE_STATUS_DATA:::::::', data, newData);
            state.detailExtTime = newData['detailExtTime'] ? newData['detailExtTime'] : state.detailExtTime;
            state.shareExtTime = newData['shareExtTime'] ? newData['shareExtTime'] : state.shareExtTime;
            state.collateExtTime = newData['collateExtTime'] ? newData['collateExtTime'] : state.collateExtTime;
            state.aitips = newData['aitips'] ? newData['aitips'] : state.aitips;
        }
    },
    actions: {
        getAllExtList({dispatch, commit, state}) {
            if(state.gotAllExtList) { return; }
            API.getAllExtList({}, function(data){
                state.gotAllExtList = true;
                console.log('getAllExtList:::::::', data);
                commit(types.REMINDER_UPDATE_STATUS_DATA, data);
                dispatch('reminder/checkReportAIStatus', null, {root: true})
            });
        },
        udpateExtList({commit, state}, params) {
            console.log('udpateExtList-----', params);
            API.updateExtList({
                info: JSON.stringify(params.params)
            }, function(data) {
                console.log('udpateExtList:::::::', data);
                commit(types.REMINDER_UPDATE_STATUS_DATA, data);
                // 执行回调函数
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        checkDetailExtTime({state}) {
            console.log('checkDetailExtTime-------', state.detailExtTime)
            if(state.detailExtTime['name'] == 1 && state.detailExtTime['fate'] == 1 && state.detailExtTime['share'] == 1 && state.detailExtTime['label'] == 1) {
                state.showDetailReminder = false;
            }else {
                state.showDetailReminder = true;
            }
        },
        checkShareExtTime({state}) {
            console.log('checkShareExtTime-------', state.shareExtTime)
            if(state.shareExtTime['save'] == 1 && state.shareExtTime['collate'] == 1) {
                state.showShareReminder = false;
            }else {
                state.showShareReminder = true;
            }
        },
        checkCollateExtTime({state}) {
            console.log('checkCollateExtTime-------', state.collateExtTime)
            if(state.collateExtTime['float'] == 1 && state.collateExtTime['label'] == 1) {
                state.showCollateReminder = false;
            }else {
                state.showCollateReminder = true;
            }
        },
        checkReportAIStatus({dispatch, state}) {
            console.log('checkReportAIStatus-------', state.aitips)
            // // for test
            // state.aiButtonClickedStatus = false;
            // var params = {"aitips": ''};
            // dispatch('reminder/udpateExtList', {
            //     params: params
            // }, {root: true});
            // return;
            var curTime = MOMENT_TIME.getTimeStampByNow();
            if(!state.aitips) {
                var params = {"aitips": curTime};
                dispatch('reminder/udpateExtList', {
                    params: params
                }, {root: true});
                state.aiButtonClickedStatus = false;
            }else {
                if(state.aitips == 1) {
                    state.aiButtonClickedStatus = true;
                }else {
                    var dValue = curTime - parseInt(state.aitips),
                        compValue = 7 * 24 * 3600; // 7天
                        // compValue = 300; // 5分钟 for test
                    state.aiButtonClickedStatus = dValue > compValue ? true : false;
                    console.log('checkReportAIStatus-------相差时间', dValue)
                }
            }
        },
        resetData({state}) {
            state.gotAllExtList = false;
        }
    }
}
